const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  '/api';

export function apiUrl(ruta) {
  const rutaLimpia = ruta.startsWith('/')
    ? ruta
    : `/${ruta}`;

  return `${API_BASE_URL}${rutaLimpia}`;
}

export default API_BASE_URL;